import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

function ReviewerDashboard() {
  const PlatformID = localStorage.getItem('platformID');
  const reviewerID = localStorage.getItem('reviewerID');
  const API = process.env.REACT_APP_API_BASE_URL;

  const [totalAssigned, setTotalAssigned] = useState(0);
  const [acceptedCount, setAcceptedCount] = useState(0);
  const [rejectedCount, setRejectedCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [acceptWithComm, setAcceptWithComm] = useState(0);

  const [acceptedAbstract, setAcceptedAbstract] = useState(0);
  const [pendingAbstract, setPendingAbstract] = useState(0);
  const [rejectedAbstract, setRejectedAbstract] = useState(0);
  const [totalAbstract, setTotalAbstract] = useState(0);

  const [acceptedFull, setAcceptedFull] = useState(0);
  const [pendingFull, setPendingFull] = useState(0);
  const [rejectedFull, setRejectedFull] = useState(0);
  const [acceptWithCommentFull, setAcceptWithCommentFull] = useState(0);
  const [totalFull, setTotalFull] = useState(0);

  const [acceptedRevision, setAcceptedRevision] = useState(0);
  const [pendingRevision, setPendingRevision] = useState(0);
  const [rejectedRevision, setRejectedRevision] = useState(0);
  const [totalRevision, setTotalRevision] = useState(0);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const dashboardRes = await axios.get(`${API}/api/reviewer/${PlatformID}/${reviewerID}`);

        // ✅ Log the full response from API
        // console.log('Reviewer Dashboard API Response:', dashboardRes.data);

        const total = dashboardRes.data.assignments ?? 0;
        const accept = dashboardRes.data.stats?.accept_count ?? 0;
        const reject = dashboardRes.data.stats?.reject_count ?? 0;
        const withComm = dashboardRes.data.stats?.acceptWithComm ?? 0;

        const pending = dashboardRes.data.overall?.Pending;

        setTotalAssigned(total);
        setAcceptedCount(accept);
        setRejectedCount(reject);
        setPendingCount(pending);
        setAcceptWithComm(withComm);


        const breakdown = dashboardRes.data.paperBreakdown;

        // Abstract
        setTotalAbstract(breakdown.abstract?.total || 0);
        setAcceptedAbstract(breakdown.abstract?.Accept || 0);
        setPendingAbstract(breakdown.abstract?.Pending || 0);
        setRejectedAbstract(breakdown.abstract?.Reject || 0);

        // Full
        setTotalFull(breakdown.full?.total || 0);
        setAcceptedFull(breakdown.full?.Accept || 0);
        setPendingFull(breakdown.full?.Pending || 0);
        setRejectedFull(breakdown.full?.Reject || 0);
        setAcceptWithCommentFull(breakdown.full?.AcceptWithComment || 0);

        // Revision
        setTotalRevision(breakdown.revision?.total || 0);
        setAcceptedRevision(breakdown.revision?.Accept || 0);
        setPendingRevision(breakdown.revision?.Pending || 0);
        setRejectedRevision(breakdown.revision?.Reject || 0);
      } catch (error) {
        console.error('Error fetching reviewer dashboard stats:', error);
      }
    };

    if (PlatformID && reviewerID) {
      fetchStats();
    }
  }, [PlatformID, reviewerID, API]);


  // ✅ Reusable Dashboard Box
  const DashboardBox = ({ label, count, bg, to, state }) => (
    <div className="col-lg-3 col-6 mb-4">
      <Link to={to} state={state} className="text-decoration-none">
        <div className={`small-box bg-${bg}`}>
          <div className="inner">
            <h3>{count}</h3>
            <p>{label}</p>
          </div>
        </div>
      </Link>
    </div>
  );

  return (
    <div className="ml-2">
      <div className="content-header">
        <div className="container-fluid">
          <h1 className="m-0 page-title">Reviewer Dashboard</h1>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">

          {/* Overall Stats */}
          <div className="row">
            <DashboardBox label="Total Assigned Submissions" count={totalAssigned} bg="info" to="/reviewer/review-all-papers" state={{ type: 'all', status: 'all' }} />
            <DashboardBox label="Accepted Submissions" count={acceptedCount} bg="success" to="/reviewer/review-all-papers" state={{ type: 'all', status: 'Accept' }} />
            <DashboardBox label="Pending Submissions" count={pendingCount} bg="warning" to="/reviewer/review-submissions?filter=notReviewed" />
            <DashboardBox label="Rejected Submissions" count={rejectedCount} bg="danger" to="/reviewer/review-all-papers" state={{ type: 'all', status: 'Reject' }} />
          </div>

          {/* Abstract Papers */}
          <h3 className="mt-4">Abstract Papers</h3>
          <div className="row">
            <DashboardBox label="Total Submissions" count={totalAbstract} bg="primary" to="/reviewer/review-all-papers" state={{ type: 'abstract' }} />
            <DashboardBox label="Accepted Submissions" count={acceptedAbstract} bg="success" to="/reviewer/review-all-papers" state={{ type: 'abstract', status: 'Accept' }} />
            <DashboardBox label="Pending Submissions" count={pendingAbstract} bg="warning" to="/reviewer/review-submissions?filter=notReviewed" />
            <DashboardBox label="Rejected Submissions" count={rejectedAbstract} bg="danger" to="/reviewer/review-all-papers" state={{ type: 'abstract', status: 'Reject' }} />
          </div>

          {/* Full Papers */}
          <h3 className="mt-4">Full Papers</h3>
          <div className="row ">
            <DashboardBox label="Total Submissions" count={totalFull} bg="primary" to="/reviewer/review-all-papers" state={{ type: 'full' }} />
            <DashboardBox label="Accepted Submissions" count={acceptedFull} bg="success" to="/reviewer/review-all-papers" state={{ type: 'full', status: 'Accept' }} />
            <DashboardBox label="Pending Submissions" count={pendingFull} bg="warning" to="/reviewer/review-submissions?filter=notReviewed" />
            <DashboardBox label="Rejected Submissions" count={rejectedFull} bg="danger" to="/reviewer/review-all-papers" state={{ type: 'full', status: 'Reject' }} />
            <DashboardBox label="Comments on Submissions" count={acceptWithCommentFull} bg="info" to="/reviewer/review-all-papers" state={{ type: 'full', status: 'AcceptWithComment' }} />
          </div>

          {/* Revision Papers */}
          <h3 className="mt-4">Revision Papers</h3>
          <div className="row">
            <DashboardBox label="Total Submissions" count={totalRevision} bg="primary" to="/reviewer/review-all-papers" state={{ type: 'revision' }} />
            <DashboardBox label="Accepted Submissions" count={acceptedRevision} bg="success" to="/reviewer/review-all-papers" state={{ type: 'revision', status: 'Accept' }} />
            <DashboardBox label="Pending Submissions" count={pendingRevision} bg="warning" to="/reviewer/review-submissions?filter=notReviewed" />
            <DashboardBox label="Rejected Submissions" count={rejectedRevision} bg="danger" to="/reviewer/review-all-papers" state={{ type: 'revision', status: 'Reject' }} />
          </div>

        </div>
      </section>
    </div>
  );
}

export default ReviewerDashboard;
